var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeBlue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 366,
    viewBox: "0 0 407 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.581 220.418C40.635 219.013 75.9885 256.209 -73.6472 353.469C-97.5767 365.241 -127.536 371.17 -150.081 356.921C-246.674 282.746 -57.4502 28.6097 23.5155 -9.06211C132.522 -77.9495 315.393 -90.6604 392.457 27.3711C411.515 67.5502 414.371 126.652 375.858 154.512C335.105 183.992 293.563 213.14 242.581 220.418Z",
    fill: "#78BEE1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBlue1);
export default __webpack_public_path__ + "static/media/welcome-blue1.2c84a1b7920d8f786934d66c5fe92ff3.svg";
export { ForwardRef as ReactComponent };